import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBeMypLRbHg6kyyggiD-XkmuZ86mMowkBQ",
  authDomain: "cover-letter-app-bc5b3.firebaseapp.com",
  projectId: "cover-letter-app-bc5b3",
  storageBucket: "cover-letter-app-bc5b3.firebasestorage.app",
  messagingSenderId: "1066484346480",
  appId: "1:1066484346480:web:eea62510f10671b809ceb5",
  measurementId: "G-SQVK2HEV1L"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
